module.exports = __webpack_public_path__ + "static/customer-testimonial-bg-6-tablet-b8b0cd0cf2c486a8eed549d733098568.png";